import { EmailValidator } from "commons-validator-js";

export default {
  data() {
    return {
      errors: {}, // Holds error messages and sub messages for specified fields.
      /**
       * errors :{
       * 'Question' : { 'errorMsg' : ' Question Body must not be empty. }
       * }
       */
    };
  },
  computed: {
    hasError() {
      return (fieldName) => {
        return this.errors && !!this.errors[fieldName];
      };
    },
    getErrorMsg() {
      return (fieldName) => {
        const error = this.errors[fieldName];
        if (!error) return "";
        return error.errorMsg;
      };
    },
  },
  methods: {
    clearValidationError() {
      this.errors = {};
    },
    handleCloseError(fieldName) {
      // remove error for specific field from map
      delete this.errors[fieldName];
      this.errors = Object.assign({}, this.errors);
    },
    //default only allow WholeNumber
    validateNumberInput(fieldValue, params) {
      fieldValue = Number.parseFloat(fieldValue);
      if (isNaN(fieldValue)) return false;

      const min = params.min;
      const max = params.max;
      const steps = params.steps ? params.steps : 1;
      const allowDecimal = params.allowDecimal ? params.allowDecimal : false;

      if (!allowDecimal && fieldValue % 1 != 0) return false;

      if (fieldValue < min || fieldValue > max) return false;

      // check if value is allowed based on incremental or decremental value
      if (steps > 1 && fieldValue % steps !== 0) return false;

      return true;
    },
    validateEmail(value) {
      const validator = new EmailValidator();
      return validator.isValid(value);
    },
    setFieldError(fieldName, errorMsg) {
      this.errors[fieldName] = { errorMsg: errorMsg };
    },
    validateHalfMarkInput(value, minMax) {
      if (isNaN(value) || value === null || value === "") return false;

      const min = minMax.min;
      const max = minMax.max;
      if (value < min || value > max) return false;

      // check the decimal part
      const decimalPart = value % 1;
      if (decimalPart === 0 || decimalPart === 0.5) return true;
    },
  },
};
